import { render, staticRenderFns } from "./ProjectStatusRenderer.vue?vue&type=template&id=cdde0a54&"
import script from "./ProjectStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports